import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { getPasswordPolicyTranslationKey, isByValuePolicy, isRuleMatched, PasswordPolicy } from '@ebeihilfe/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ebeihilfe-progress-bar',
  templateUrl: 'progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  public readonly getPasswordPolicyTranslationKey = getPasswordPolicyTranslationKey;
  public readonly isByValuePolicy = isByValuePolicy;
  public value = input.required<string>();
  public rules = input.required<PasswordPolicy[]>();
  public inMobile = Capacitor.isNativePlatform();

  public isRuleMatched(rule: PasswordPolicy): boolean {
    return isRuleMatched(rule, this.value() || '');
  }
}
